//#region react imports
import { useSelector } from "react-redux";
//#endregion

//#region functions imports
import { getTranslations } from "../../Helper/TranslationController";
//#endregion

//#region constants imports
import { FOLDER_TRANSLATION_KEY } from "../../Constants/Documentation";
//#endregion

//#region style import
import "./DocumentationMenu.style.scss";
//#endregion

const DocumentationMenu = ({
  iconTitle,
  title,
  content,
  documentToShow,
  setDocumentsToShow,
  isMachineDocumentation,
}) => {
  //#region hooks
  const translations = useSelector((state) => state.translationSlice.translations);
  //#endregion
  //#region functions
  const createList = () => {
    return (
      <ul className="documentation-menu-list">
        {content &&
          Object.getOwnPropertyNames(content).map((element) => {
            return (
              <li
                key={element}
                className={`documentation-menu-list-item ${documentToShow === element ? "selected" : ""}`}
              >
                <span
                  className="documentation-menu-list-item-text"
                  onClick={() => setDocumentsToShow(element)}
                >
                  {isMachineDocumentation
                    ? getTranslations(element + "_name", translations)
                    : getTranslations(FOLDER_TRANSLATION_KEY[element], translations)}{" "}
                  {!isMachineDocumentation && element === "Notices" && <i>(Gsta / DeltaOs)</i>}
                </span>
              </li>
            );
          })}
      </ul>
    );
  };
  //#endregion

  return (
    <>
      <div className="documentation-menu-title">
        {iconTitle}
        <span className="documentation-menu-title-text">{title}</span>
      </div>
      {createList()}
    </>
  );
};

export default DocumentationMenu;
